<template>
  <div>
    <pdl-callout v-if="claimData.id" icon="history" qaid="warranty-claim-save-disclaimer">
      <template #content>
        <span v-html="savedDisclaimer" />
      </template>
    </pdl-callout>

    <pdl-callout v-if="showErrorCallout" kind="error" qaid="warranty-claim-global-errors">
      <template #content>
        <span v-html="bp('formGlobalError')" />
      </template>
    </pdl-callout>

    <pdl-callout
      v-for="(callout, calloutIndex) in claimCallouts"
      :key="calloutIndex"
      kind="error"
      qaid="warranty-claim-callout"
    >
      <template #content>
        <span v-html="callout" />
      </template>
    </pdl-callout>

    <section-header size="xl" variants="dividing" class="mt-3">
      <heading :level="1" size="xl" qaid="warranty-claim-header" v-html="claimHeader" />
    </section-header>

    <p qaid="warranty-claim-fields-required" v-html="bp('allFieldsRequired')" />

    <section class="mt-5">
      <!-- Header -->
      <section-header size="md" variants="dividing" class="mb-3">
        <heading :level="1" size="md" qaid="warranty-claim-contact-info" v-html="bp('claimContactInfo')" />
      </section-header>

      <!-- Contact Info -->
      <div class="grid-x grid-margin-x">
        <div class="cell medium-4">
          <form-group
            v-validate="'required'"
            type="text"
            name="contactName"
            qaid="warranty-claim-contact-person"
            :error="errors.first('contactName')"
            :show-error-messages="true"
            :data-vv-as="bp('contactPerson')"
            :label="bp('contactPerson')"
            :required="true"
            :value="claimData.contactName"
            @blur="updateVuex"
          />
        </div>
        <div class="cell medium-4">
          <form-group
            v-validate="'required'"
            type="text"
            name="contactPhoneNumber"
            qaid="warranty-claim-contact-phone"
            :maxlength="26"
            :error="errors.first('contactPhoneNumber')"
            :show-error-messages="true"
            :data-vv-as="bp('phone')"
            :label="bp('phone')"
            :required="true"
            :value="claimData.contactPhoneNumber"
            @blur="updateVuex"
          />
        </div>
        <div class="cell medium-4">
          <form-group
            type="text"
            name="contactEmail"
            qaid="warranty-claim-contact-email"
            :label="bp('email')"
            :value="claimData.contactEmail"
            @blur="updateVuex"
          />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import SectionHeader from '@/components/SectionHeader';
import Heading from '@/components/Heading';
import {PdlCallout} from '@pedal/pdl-callout';
import FormGroup from '@/components/FormGroup';
import {mapActions} from 'vuex';

export default {
  inject: ['$validator'],
  components: {SectionHeader, Heading, PdlCallout, FormGroup},
  props: {
    baseProperties: {
      type: Array,
      required: true,
    },
    claimData: {
      type: Object,
      required: true,
    },
    showSuccess: {
      type: Boolean,
      default: false,
    },
    claimNumber: {
      type: String,
      required: true,
    },
  },

  computed: {
    isNewClaim() {
      return this.claimData && this.claimData.status === 'enumClaimStatusNew';
    },

    savedDisclaimer() {
      if (this.claimData && this.claimData.lastSavedTime) {
        // Transform server GMT Time to local browser time
        const newDate = new Date(this.claimData.lastSavedTime);

        if (newDate instanceof Date && !isNaN(newDate)) {
          const timeZone = newDate.toString().match(/\((.*)\)/)[1];
          const minutes = newDate
            .getMinutes()
            .toString()
            .padStart('2', 0);

          return this.bp('lastSaved', this.claimData.lastSavedDate, `${newDate.getHours()}:${minutes} ${timeZone}`);
        }
      }

      return '';
    },

    claimHeader() {
      if (!this.claimData.id) {
        return this.bp('newClaim');
      }

      return this.bp('claimNumber', this.claimData.id);
    },

    claimCallouts() {
      let callouts = [];

      if (this.claimData && this.claimData.claimLines) {
        this.claimData.claimLines.forEach((claimLine, claimIndex) => {
          if (claimLine.waitingCodeList) {
            claimLine.waitingCodeList.forEach((code) => {
              switch (code) {
                case 'D':
                  callouts.push(this.bp('damageImage', claimIndex + 1));
                  break;
                case 'S':
                  callouts.push(this.bp('validSerial', claimIndex + 1));
                  break;
                case 'F':
                  callouts.push(this.bp('sizeRequired', claimIndex + 1));
                  break;
                case 'I':
                  callouts.push(this.bp('warningImage', claimIndex + 1));
                  break;
              }
            });
          }
        });
      }

      return callouts;
    },

    showErrorCallout() {
      return this.$validator.errors.items.length;
    },
  },

  methods: {
    updateVuex(e) {
      this.updateProperty({
        propName: e.target.getAttribute('name'),
        value: e.target.value,
      });
    },

    redirect() {
      window.location = `${ACC.config.encodedContextPath}/warranty-claim/all-warranty-claims/`;
    },

    ...mapActions('warrantyClaims', ['updateProperty']),
  },
};
</script>
